"use client";
import Image from "next/image";
import {
  battery,
  camera,
  display,
  microchip,
  processor,
  rectangle,
  screen,
  stroke,
  storeIcon,
  tv,
  desktoptype,
  calender,
  money,
} from "../../../public/icons";
import {
  Badge,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from "react-bootstrap";
import styles from "../../styles/SpecDetail.module.css";
import { useQuery } from "@tanstack/react-query";
import {
  fetchIsListingAvailableForModel,
  fetchItem,
  fetchRecommendedModels,
  fetchVariantsForModel,
} from "../../app/apis/getApis";
import React, { useEffect, useState } from "react";
import DOMPurify from "isomorphic-dompurify";
import ImageCarousel from "../../components/ImageCarousel";
import ProductCard from "./ProductCard";
import ProductCardLoading from "./ProductCardLoading";
import { useParams, useRouter } from "next/navigation";
import imagePlaceholder from "../../../public/images/imagePlaceholder.png";
import { marketplaceCdn } from "../../utility/env";
import Breadcrumbs from "../../components/Breadcrumb";
import Select from "react-select";
import Link from "next/link";
import { useUserStore } from "../../store/User";

const featuredData = (categoryId: number) => {
  switch (categoryId) {
    case 1:
      return [
        {
          specialCondition: null,
          icon: rectangle,
          title: {
            sect: "display",
            key: "Size",
          },
          description: {
            sect: "display",
            key: "Resolution",
          },
        },
        {
          specialCondition: null,
          icon: microchip,
          title: {
            sect: "processor",
            key: "Processor",
          },
          description: {
            sect: "processor",
            key: "Generation",
          },
        },
        {
          specialCondition: null,
          icon: stroke,
          title: {
            sect: "graphics",
            key: "Type",
          },
          description: {
            sect: "graphics",
            key: "Name",
          },
        },
        {
          specialCondition: null,
          icon: processor,
          title: {
            sect: "storage",
            key: "RAM",
          },
          description: {
            sect: "storage",
            key: "RAM Type",
          },
        },
        
      ];
    case 2:
      return [
        {
          specialCondition: null,
          icon: money,
          special: "Launch Price",
          title: {
            sect: "price",
            key: "Launch Price",
          },
          // description: { sect: "price", key: "text" },
        },
        {
          specialCondition: null,
          icon: rectangle,
          title: {
            sect: "display",
            key: "Size",
          },
          description: {
            sect: "display",
            key: "Resolution",
          },
        },
        {
          specialCondition: null,
          icon: camera,
          special: "Camera",
          title: {
            sect: "general",
            key: "Camera Specs",
          },
        },
        {
          specialCondition: null,
          icon: stroke,
          special: "Processor",
          title: {
            sect: "general",
            key: "Processor",
          },
          // description: {
          //   sect: "general",
          //   key: "Processor",
          // },
        },
        {
          specialCondition: null,
          icon: battery,
          special: "Battery",

          title: {
            sect: "battery",
            key: "Capacity",
          },
        },
        {
          specialCondition: null,
          icon: calender,
          special: "Release Date",
          title: {
            sect: "launch",
            key: "Release Date",
          },
          // description: { sect: "launch", key: "text" },
        },
      ];
    case 3:
      return [
        {
          specialCondition: null,
          icon: rectangle,
          title: {
            sect: "display",
            key: "Size",
          },
          description: {
            sect: "display",
            key: "Resolution",
          },
        },
        {
          specialCondition: null,
          icon: camera,
          special: "Camera",

          title: {
            sect: "general",
            key: "Camera Specs",
          },
        },
        {
          specialCondition: null,
          icon: stroke,
          special: "Processor",
          title: {
          sect: "general",
            key: "Processor", 
          },
          
        },
        {
          specialCondition: null,
          icon: battery,
          special: "Battery",
          title: {
            sect: "battery",
            key: "Capacity",
          },
        },
        // {
        //   specialCondition: null,
        //   icon: calender,
        //   title: {
        //     sect: "launch",
        //     key: "date",
        //   },
        //   description: { sect: 'launch', key: 'text' }

        // },
        // {
        //   specialCondition: null,
        //   icon: money,
        //   title: {
        //     sect: "price",
        //     key: "value",

        //   },
        //   description: { sect: 'price', key: 'text' }

        // },
      ];
    case 4:
      return [
        {
          specialCondition: null,
          icon: money,
          special: "Lauch Price",
          title: {
            sect: "price",
            key: "Launch Price",
          },
          // description: { sect: "price", key: "text" },
        },
        {
          specialCondition: null,
          icon: rectangle,
          title: {
            sect: "display",
            key: "Size",
          },
        },
        {
          specialCondition: null,
          icon: display,
          title: {
            sect: "display",
            key: "Resolution",
          },
        },
        {
          specialCondition: null,
          icon: screen,
          title: {
            sect: "display",
            key: "Screen Type",
          },
        },
        {
          specialCondition: null,
          icon: tv,
          title: {
            sect: "sim_support",
            key: "Smart TV",
            keyTitle: "Smart TV:",
          },
          description: {
            sect: "sim_support",
            key: "TV Certification",
            keyTitle: "TV Certification: ",
          },
        },
        {
          specialCondition: null,
          icon: calender,
          special: "Release Date",

          title: {
            sect: "launch",
            key: "Release Date",
          },
        },
      ];
    case 5:
      return [
        {
          specialCondition: null,
          icon: processor,
          title: {
            sect: "processor",
            key: "Processor",
          },
          description: {
            sect: "processor",
            key: "Generation",
            keyTitle: "Generation: ",
          },
        },
        {
          specialCondition: null,
          icon: microchip,
          title: {
            sect: "graphics",
            key: "Type",
          },
          description: {
            sect: "graphics",
            key: "Name",
          },
        },
        {
          specialCondition: null,
          icon: stroke,
          title: {
            sect: "storage",
            key: "RAM",
          },
          description: {
            sect: "storage",
            key: "RAM Type",
          },
        },
        {
          specialCondition: {
            condition: {
              sect: "general",
              key: "Desktop Type",
              value: "All in one",
            },
            icon: display,
            title: {
              sect: "display",
              key: "Size",
            },
            description: {
              sect: "display",
              key: "Resolution",
            },
          },
          icon: desktoptype,
          title: {
            sect: "general",
            key: "Desktop Type",
          },
        },
        // {
        //   specialCondition: null,
        //   icon: calender,
        //   title: {
        //     sect: "launch",
        //     key: "date",
        //   },
        //   description: { sect: 'launch', key: 'text' }

        // },
        // {
        //   specialCondition: null,
        //   icon: money,
        //   title: {
        //     sect: "price",
        //     key: "value",

        //   },
        //   description: { sect: 'price', key: 'text' }

        // },
      ];

    default:
      return [];
  }
};

const ColorThumbnail = ({
  name,
  isActive = false,
  setSelection,
  imageUrl,
  color,
}: any) => {
  const [imageSrc, setImageSrc] = useState<any>(
    `${marketplaceCdn}/${imageUrl}`
  );
  return (
    <div
      className={`${styles.colorThumbnail} ${isActive ? styles.activeColor : ""}`}
      onClick={() => {
        setSelection(color);
      }}
    >
      <Image
        alt={name}
        src={imageSrc}
        width={100}
        height={100}
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        onError={() => {
          setImageSrc(`${imagePlaceholder.src}`);
        }}
      />
    </div>
  );
};
const SpecDetail = () => {
  const router = useRouter();

  const [selectedTab, setSelectedTab] = useState("description");
  const [selectedColor, setSelectedColor] = useState<any | null>(null);
  const [variants, setVariants] = useState([]);
  const [options, setOptions] = useState();
  // const suseSearchParams()

  const [variamtValue, setvariamtValue] = useState();
  const { user, token } = useUserStore((state: any) => state);

  const params = useParams();

  const categories: { [key: string]: number } = {
    mobile: 2,
    tablet: 3,
    "tv-monitor": 4,
    laptop: 1,
    "desktop-computer": 5,
    accessories: 6,
  };
  let paramArray = params.model.split("-");
  const [modelId, setModelId] = useState(paramArray[paramArray.length - 1]);

  let categoryId = +categories[params.category];
  let category = params.category;
  params.model;
  // variants
  const getSpecsItem = useQuery({
    queryKey: ["specsCentralPdp", modelId],
    queryFn: () => fetchItem(modelId),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: !!(modelId && categoryId),
    onSuccess: (data) => {
      setSelectedColor(data?.data?.body?.data?.colors[0]);
    },
    onError: (error: any) => {
      error.response.status === 500 && router.replace("/404");
    },
  });

  const getRelatedModelQuery = useQuery({
    queryKey: ["specsCentralRecommendedProducts", categoryId, modelId],
    queryFn: () => fetchRecommendedModels(modelId),
    enabled: !!modelId,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
  const isListingAvailableQuery = useQuery({
    queryKey: ["specsCentralAvailabilityListingAgainstModel", modelId],
    queryFn: () => fetchIsListingAvailableForModel(modelId),
    enabled: !!modelId,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
  const getVriants = useQuery({
    queryKey: ["variants", [modelId]],
    queryFn: () =>
      fetchVariantsForModel(
        modelId,
        getSpecsItem?.data?.data?.body?.data.basic?.Model
      ),
    enabled:
      !!modelId && getSpecsItem?.data?.data?.body?.data.basic?.Model
        ? true
        : false,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setVariants(data?.data?.body?.data);
      setOptions(
        data?.data?.body?.data.map((item: any) => {
          if (category === "tv-monitor") {
            const varAr = item.variant.split(" ");
            return {
              value: item.model_id,
              label: varAr[0] + " inches " + varAr[1] + "Hz",
            };
          } else {
            return { value: item.model_id, label: item.variant };
          }
        })
      );
      setvariamtValue({
        value: modelId,
        label: params.model.split("-").slice(0, -1).join("-"),
      });
    },
  });
  const sanitizedHTML = DOMPurify.sanitize(
    getSpecsItem?.data?.data?.body?.data?.basic?.Description
  );
  const capitalize = (data: any) => {
    return data.charAt(0).toUpperCase() + data.slice(1);
  };

  const formatTitleForTVMonitor = (title: string): string => {
    if (title) {
      const words = title.split(" ");
      words[words.length - 2] = words[words.length - 2] + " inches";
      words[words.length - 1] = words[words.length - 1] + "Hz";
      return words.join(" ");
    } else {
      return "";
    }
  };

  useEffect(() => {
    if (
      sanitizedHTML.length <= 0 ||
      sanitizedHTML.replace(/(<([^>]+)>)/gi, "").length <= 1
    ) {
      setSelectedTab("specification");
    } else {
      setSelectedTab("description");
    }
  }, [sanitizedHTML]);

  return (
    <>
      <Breadcrumbs />
      <Row className="my-4 mt-lg-3 mt-5">
        <Col xs="12" sm="12" md="12" lg="12">
          <div className="ps-2 ps-lg-3">
            <Row>
              <Col lg="6" md="6">
                {getSpecsItem?.data?.data?.body?.data?.colors &&
                getSpecsItem?.data?.data?.body?.data?.colors?.length > 0 &&
                selectedColor ? (
                  <div className={`row`}>
                    <div className={`col-12 col-sm-10 col-md-12`}>
                      <ImageCarousel fetchedData={selectedColor.images} />
                    </div>
                    <div className="col-2 d-none d-sm-block d-md-none">
                      {selectedColor ? (
                        <>
                          <h6
                            className={`pb-1 pt-2 ${styles.verticalColorsHeading}`}
                          >
                            Color:
                            <br />
                            {selectedColor?.color_name}
                          </h6>
                          <div
                            className={`d-flex gap-2 flex-column ${styles.verticalColorsDesign}`}
                          >
                            {selectedColor ? (
                              getSpecsItem?.data?.data?.body?.data?.colors.map(
                                (color: any, index: number) => (
                                  <ColorThumbnail
                                    color={color}
                                    key={color.color_id}
                                    name={color.color_name}
                                    isActive={
                                      selectedColor?.color_id === color.color_id
                                    }
                                    setSelection={setSelectedColor}
                                    imageUrl={color.images[0]}
                                  />
                                )
                              )
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Col>
              <Col lg="6" md="6">
                <section className={`d-flex flex-column`}>
                  <div>
                    <div className={`p-0 mt-2`}>
                      <div className={styles.specs}>
                        <h1 className="fw-bold ">
                          {category === "tv-monitor"
                            ? formatTitleForTVMonitor(
                                getSpecsItem?.data?.data?.body?.data.basic
                                  ?.Title
                              )
                            : getSpecsItem?.data?.data?.body?.data.basic?.Title}
                        </h1>
                      </div>
                    </div>
                    <Container fluid>
                      <Row className={`${styles.specBasic}`}>
                        {featuredData(categoryId)?.map(
                          (outerKey: any, index: number) => (
                            <Col xs="6" sm="6" md="6" lg="6" key={index}>
                              {outerKey?.specialCondition &&
                              getSpecsItem?.data?.data?.body?.data[
                                outerKey?.specialCondition.condition.sect
                              ][outerKey?.specialCondition.condition.key] ===
                                outerKey?.specialCondition.condition.value ? (
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      {" "}
                                      {
                                        outerKey?.specialCondition.title
                                          .keyTitle
                                      }
                                      {
                                        getSpecsItem?.data?.data?.body?.data[
                                          outerKey?.specialCondition.title.sect
                                        ][outerKey?.specialCondition.title.key]
                                      }
                                    </Tooltip>
                                  }
                                >
                                  <div className="d-flex align-items-center gap-3 mb-4 mt-4">
                                    <div
                                      style={{
                                        width: "30px",
                                        minWidth: "30px",
                                        height: "30px",
                                      }}
                                    >
                                      <Image
                                        src={outerKey?.specialCondition.icon}
                                        alt="icon-1"
                                        width={300}
                                        height={300}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                    </div>
                                    <div className="w-100">
                                      <span
                                        className={`m-0  fw-bold d-inline-block text-truncate ${styles.keyTitle}`}
                                        style={{ maxWidth: "130px" }}
                                      >
                                        {outerKey?.specialCondition.title.hasOwnProperty(
                                          "keyTitle"
                                        )
                                          ? outerKey?.specialCondition.title
                                              .keyTitle
                                          : ""}
                                        {
                                          getSpecsItem?.data?.data?.body?.data[
                                            outerKey?.specialCondition.title
                                              .sect
                                          ][
                                            outerKey?.specialCondition.title.key
                                          ]
                                        }
                                      </span>

                                      {outerKey?.specialCondition
                                        ?.description ? (
                                        outerKey?.specialCondition?.description.hasOwnProperty(
                                          "keyTitle"
                                        ) ? (
                                          <p className="m-0 fs-13">
                                            {
                                              outerKey?.specialCondition
                                                .description.keyTitle
                                            }
                                            {
                                              getSpecsItem?.data?.data?.body
                                                ?.data[
                                                outerKey?.specialCondition
                                                  .description.sect
                                              ][
                                                outerKey?.specialCondition
                                                  .description.key
                                              ]
                                            }
                                            {outerKey?.specialCondition
                                              .description?.unit
                                              ? ` ${outerKey?.specialCondition.description?.unit}`
                                              : ""}
                                          </p>
                                        ) : (
                                          <p className="m-0 fs-13">
                                            {
                                              getSpecsItem?.data?.data?.body
                                                ?.data[
                                                outerKey?.specialCondition
                                                  .description.sect
                                              ][
                                                outerKey?.specialCondition
                                                  .description.key
                                              ]
                                            }
                                            {outerKey?.specialCondition
                                              .description?.unit
                                              ? ` ${outerKey?.specialCondition.description?.unit}`
                                              : ""}
                                          </p>
                                        )
                                      ) : (
                                        <p></p>
                                      )}
                                    </div>
                                  </div>
                                </OverlayTrigger>
                              ) : (
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      {" "}
                                      {outerKey.title.keyTitle}
                                      {
                                        getSpecsItem?.data?.data?.body?.data[
                                          outerKey.title.sect
                                        ][outerKey.title.key]
                                      }
                                    </Tooltip>
                                  }
                                >
                                  <div className="d-flex align-items-center gap-3 mb-4 mt-4">
                                    <div
                                      style={{
                                        width: "30px",
                                        minWidth: "30px",
                                        height: "30px",
                                      }}
                                    >
                                      <Image
                                        src={outerKey.icon}
                                        alt="icon-2"
                                        width={300}
                                        height={300}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                    </div>
                                    <div className="w-100">
                                      <span
                                        className={`m-0 fw-bold d-inline-block text-truncate ${styles.keyTitle}`}
                                        style={{ maxWidth: "130px" }}
                                      >
                                        {outerKey.title.hasOwnProperty(
                                          "keyTitle"
                                        )
                                          ? outerKey.title.keyTitle
                                          : ""}
                                        {
                                          getSpecsItem?.data?.data?.body?.data[
                                            outerKey.title.sect
                                          ][outerKey.title.key]
                                        }
                                      </span>

                                      {outerKey?.description ? (
                                        outerKey?.description.hasOwnProperty(
                                          "keyTitle"
                                        ) ? (
                                          <p className="m-0 fs-13">
                                            {outerKey.description.keyTitle}
                                            {
                                              getSpecsItem?.data?.data?.body
                                                ?.data[
                                                outerKey.description.sect
                                              ][outerKey.description.key]
                                            }
                                            {outerKey.description?.unit
                                              ? ` ${outerKey.description?.unit}`
                                              : ""}
                                          </p>
                                        ) : (
                                          <p className="m-0 fs-13">
                                            {
                                              getSpecsItem?.data?.data?.body
                                                ?.data[
                                                outerKey.description.sect
                                              ][outerKey.description.key]
                                            }
                                            {outerKey.description?.unit
                                              ? ` ${outerKey.description?.unit}`
                                              : ""}
                                          </p>
                                        )
                                      ) : (
                                        <p className="m-0 fs-13">
                                          {outerKey.special}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </OverlayTrigger>
                              )}
                            </Col>
                          )
                        )}
                      </Row>
                    </Container>
                  </div>
                  {getSpecsItem?.data?.data?.body?.data?.colors &&
                  getSpecsItem?.data?.data?.body?.data?.colors?.length > 0 ? (
                    <div
                      className={`${styles.colorDiv} d-block d-sm-none d-md-block`}
                    >
                      <h6 className={`pb-1 pt-2`}>
                        Color: {selectedColor?.color_name}
                      </h6>
                      <div
                        className={`d-flex gap-2 flex-sm-nowrap flex-md-wrap`}
                      >
                        {getSpecsItem?.data?.data?.body?.data?.colors.map(
                          (color: any) => (
                            <ColorThumbnail
                              color={color}
                              key={color.color_id}
                              name={color.color_name}
                              isActive={
                                selectedColor?.color_id === color.color_id
                              }
                              setSelection={setSelectedColor}
                              imageUrl={color.images[0]}
                            />
                          )
                        )}
                      </div>
                      {/* {isListingAvailableQuery.isSuccess && isListingAvailableQuery.data.data.body.data.matchCriteria !== "none" ? ( */}
                      <>
                        {categoryId === 2 ||
                        categoryId === 3 ||
                        variants.length < 1 ? (
                          <div className="w-100 pt-2 d-flex gap-1 flex-nowrap">
                            {isListingAvailableQuery.isSuccess &&
                            isListingAvailableQuery.data.data.body.data
                              .matchCriteria !== "none" ? (
                              <div
                                onClick={() => {
                                  let param = new URLSearchParams();
                                  if (
                                    isListingAvailableQuery.data.data.body.data
                                      .matchCriteria === "byModelId"
                                  ) {
                                    param.append(
                                      `models`,
                                      `["${isListingAvailableQuery.data.data.body.data.modelName}"]`
                                    );
                                    param.append(
                                      `category_id`,
                                      `${isListingAvailableQuery.data.data.body.data.categoryId}`
                                    );
                                    param.append(
                                      "brand_ids",
                                      `[${isListingAvailableQuery.data.data.body.data.brandId}]`
                                    );
                                    router.push(
                                      `/products?${param.toString()}`
                                    );
                                  } else {
                                    param.append(
                                      `search`,
                                      isListingAvailableQuery.data.data.body
                                        .data.modelName
                                    );
                                    param.append(`ps`, "1");
                                    router.push(
                                      `/products?${param.toString()}`
                                    );
                                  }
                                }}
                                className={`ms-auto rounded-2 border p-2 ${styles.wantToBuyButton}`}
                              >
                                <div className={` ${styles.wantToBuyDiv}`}>
                                  <div
                                    className={` ${styles.wantToBuyButtonIcon}`}
                                  >
                                    <Image
                                      alt="want to buy?"
                                      src={storeIcon}
                                      width={100}
                                      height={100}
                                      style={{ width: "100%", height: "100%" }}
                                      className={styles.wantToBuyButtonImage}
                                    />
                                  </div>
                                  <div
                                    className={` ${styles.wantToBuyButtonText}`}
                                  >
                                    {isListingAvailableQuery.data.data.body.data
                                      .matchCriteria === "byModelId"
                                      ? "Want to buy?"
                                      : "Find something similar?"}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          <div className="w-100 pt-2 d-grid gap-1 flex-nowrap mt-2">
                            <strong>Other Variants:</strong>
                            {
                              <>
                                <div className="w-100 d-flex gap-2  ">
                                  <div className="w-75 d-grid">
                                    <Select
                                      className=""
                                      classNamePrefix={"Select"}
                                      isSearchable
                                      value={variamtValue}
                                      name="color"
                                      onChange={(e) => {
                                        if (e) {
                                          setModelId(e.value);
                                        }
                                      }}
                                      options={options}
                                      // filterOption={createFilter(filterConfig)}
                                    />
                                  </div>
                                  <div className="vr"></div>
                                  {isListingAvailableQuery.isSuccess &&
                                  isListingAvailableQuery.data.data.body.data
                                    .matchCriteria !== "none" ? (
                                    <div
                                      onClick={() => {
                                        let param = new URLSearchParams();
                                        if (
                                          isListingAvailableQuery.data.data.body
                                            .data.matchCriteria === "byModelId"
                                        ) {
                                          param.append(
                                            `model_ids`,
                                            `[${isListingAvailableQuery.data.data.body.data.modelId}]`
                                          );
                                          param.append(
                                            `category_id`,
                                            `${isListingAvailableQuery.data.data.body.data.categoryId}`
                                          );
                                          router.push(
                                            `/products?${encodeURIComponent(param.toString())}`
                                          );
                                        } else {
                                          param.append(
                                            `search`,
                                            isListingAvailableQuery.data.data
                                              .body.data.modelName
                                          );
                                          param.append(`ps`, 1);
                                          router.push(
                                            `/products?${encodeURIComponent(param.toString())}`
                                          );
                                        }
                                      }}
                                      className={` w-75 rounded-2 border p-2 ${styles.wantToBuyButton}`}
                                    >
                                      <div
                                        className={` ${styles.wantToBuyDiv}`}
                                      >
                                        <div
                                          className={` ${styles.wantToBuyButtonIcon}`}
                                        >
                                          <Image
                                            alt="want to buy?"
                                            src={storeIcon}
                                            width={100}
                                            height={100}
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                            }}
                                            className={
                                              styles.wantToBuyButtonImage
                                            }
                                          />
                                        </div>

                                        <div
                                          className={` ${styles.wantToBuyButtonText}`}
                                        >
                                          {isListingAvailableQuery.data.data
                                            .body.data.matchCriteria ===
                                          "byModelId"
                                            ? "Want to buy?"
                                            : "Find something similar?"}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            }
                          </div>
                        )}
                      </>
                      {/* ) : (
                        <></>
                      )} */}
                    </div>
                  ) : (
                    <></>
                  )}
                  {(categoryId === 2 || categoryId === 3) && (
                    <>
                      {" "}
                      <strong>Storage:</strong>
                      <div className="d-flex flex-wrap">
                        {variants?.map((item: any, index: number) => (
                          <Badge
                            key={index}
                            onClick={() => setModelId(item.model_id)}
                            className={`py-2 px-3 border me-1 my-2 me-1 cursor-pointer ${styles.badge} ${Number(modelId) === item.model_id ? styles.ActiveBadge : ""} `}
                            pill
                            bg="light"
                            text="dark"
                          >
                            {`${item.variant.split("/")[0]}GB`}-
                            {`${item.variant.split("/")[1]}GB`}
                          </Badge>
                        ))}
                      </div>
                    </>
                  )}
                </section>
              </Col>
              <>
                {isListingAvailableQuery.isSuccess &&
                isListingAvailableQuery.data.data.body.data.matchCriteria !==
                  "none" ? (
                  <Col col="12" className="d-none d-sm-block d-md-none">
                    <div className="w-100 pt-2 d-flex gap-1 flex-nowrap">
                      <div
                        onClick={() => {
                          let param = new URLSearchParams();
                          if (
                            isListingAvailableQuery.data.data.body.data
                              .matchCriteria === "byModelId"
                          ) {
                            param.append(
                              `models`,
                              `["${isListingAvailableQuery.data.data.body.data.modelName}"]`
                            );
                            param.append(
                              `category_id`,
                              `${isListingAvailableQuery.data.data.body.data.categoryId}`
                            );
                            router.push(
                              `/products?${encodeURIComponent(param.toString())}`
                            );
                          } else {
                            param.append(
                              `search`,
                              isListingAvailableQuery.data.data.body.data
                                .modelName
                            );
                            param.append(`ps`, `1`);
                            router.push(
                              `/products?${encodeURIComponent(param.toString())}`
                            );
                          }
                        }}
                        className={` rounded-2 border p-2 ${styles.wantToBuyButton}`}
                      >
                        <div className={` ${styles.wantToBuyDiv}`}>
                          <div className={` ${styles.wantToBuyButtonIcon}`}>
                            <Image
                              alt="want to buy?"
                              src={storeIcon}
                              width={100}
                              height={100}
                              style={{ width: "100%", height: "100%" }}
                              className={styles.wantToBuyButtonImage}
                            />
                          </div>
                          <div className={` ${styles.wantToBuyButtonText}`}>
                            {isListingAvailableQuery.data.data.body.data
                              .matchCriteria === "byModelId"
                              ? "Want to buy?"
                              : "Find something similar?"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ) : (
                  <></>
                )}
              </>
            </Row>

            <Row className="mt-3 flex-column-reverse flex-lg-row">
              <Col xs="12" sm="12" md="12" lg="4" className="">
                {getRelatedModelQuery?.isSuccess &&
                getRelatedModelQuery?.data?.data?.body?.data?.length === 0 ? (
                  <></>
                ) : (
                  <>
                    <h5
                      className={`mt-2 ${styles.recomendedProductsTitle} text-center`}
                    >
                      Related Models
                    </h5>
                    <div
                      className={`d-flex flex-row flex-wrap p-1 px-lg-0 gap-1 gap-sm-2 gap-md-3 gap-lg-1 justify-content-center justify-content-lg-center`}
                    >
                      {getRelatedModelQuery.isLoading ? (
                        Array.from(Array(10)).map(
                          (item: any, index: number) => (
                            <ProductCardLoading key={index} />
                          )
                        )
                      ) : getRelatedModelQuery?.data &&
                        getRelatedModelQuery?.data?.data?.body ? (
                        getRelatedModelQuery?.data?.data?.body?.data?.map(
                          (item: any, index: number) => (
                            <ProductCard
                              key={index}
                              title={item.model_title}
                              imageUrl={item.images[0]?.img0}
                              modelId={item.model_id}
                              category={category}
                            />
                          )
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </Col>
              <Col xs="12" sm="12" md="12" lg="8" className="px-1 m-0">
                <Row
                  className={`${styles.tabOptionsContainer} rounded-top w-100 m-0 `}
                >
                  <Col
                    col={6}
                    className={`${styles.tabOptions} ${selectedTab === "description" ? `${styles.activeTabOption} ${styles.endBorderImportant}` : ""}  rounded-top border-end-0`}
                    onClick={() => {
                      setSelectedTab("description");
                    }}
                  >
                    Description
                  </Col>
                  <Col
                    col={6}
                    className={`${styles.tabOptions} ${selectedTab === "specification" ? `${styles.activeTabOption} ${styles.startBorderImportant}` : ""} rounded-top border-start-0`}
                    onClick={() => {
                      setSelectedTab("specification");
                    }}
                  >
                    Specifications
                  </Col>
                </Row>
                <div
                  className={`w-100 bg-light border border-top-0 rounded-bottom`}
                >
                  {selectedTab === "description" ? (
                    <div
                      className={`p-3`}
                      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
                    ></div>
                  ) : (
                    <Table className={`${styles.specsTable} m-0 border-0`}>
                      {getSpecsItem?.data?.data?.body?.data &&
                        Object.keys(getSpecsItem?.data?.data?.body?.data)
                          .length > 0 &&
                        Object.entries(getSpecsItem?.data?.data?.body?.data)
                          ?.filter(([key, value]) => key !== "metaData")
                          ?.map(([key, value]: any, indexCat: number) => (
                            <React.Fragment key={indexCat}>
                              {!(key === "basic" || key === "colors") ? (
                                <>
                                  <thead>
                                    <caption className={styles.tablehead}>
                                      <th colSpan={12}>{capitalize(key)}</th>
                                    </caption>
                                  </thead>
                                  <tbody>
                                    {Object.entries(value)
                                      ?.filter(
                                        ([key, value]) => key !== "metaData"
                                      )
                                      ?.map(
                                        ([val, data]: any, index: number) => (
                                          <tr key={index}>
                                            <td colSpan={1}>{val}</td>
                                            <td colSpan={8}>
                                              {data === "nil" || data === "null"
                                                ? "--"
                                                : data}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </>
                              ) : (
                                <></>
                              )}
                              {key === "colors" ? (
                                <>
                                  <thead>
                                    <tr className={styles.tablehead}>
                                      <th colSpan={12}>
                                        {key.charAt(0).toUpperCase() +
                                          key.slice(1)}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td colSpan={12}>
                                        {value?.map(
                                          (color: any, index: number) => (
                                            <Badge
                                              key={index}
                                              className="my-2"
                                              pill
                                              bg=""
                                              style={{
                                                fontSize: "16px",
                                                backgroundColor: "#9f91a3",
                                                marginRight: "5px",
                                              }}
                                              className="my-1"
                                            >
                                              {color.color_name}
                                            </Badge>
                                          )
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </>
                              ) : (
                                <></>
                              )}
                            </React.Fragment>
                          ))}
                    </Table>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SpecDetail;
